export default __webpack_public_path__ + "static/media/ic-download.ca261411.svg";